import React, { useState } from 'react'
import AppInner from './AppInner/AppInner'
import { AuthProvider, useAuth } from 'oidc-react'
import { oidcConfig, logout } from 'utils/authService'
import { QueryClient, QueryCache, QueryClientProvider } from 'react-query'
import { SnackbarProvider } from 'notistack'
import { ReactQueryDevtools } from 'react-query/devtools'
import { Button } from '@mui/material'

import 'file-loader?name=firebase-messaging-sw.js!./firebase-messaging-sw.js'
import 'file-loader?name=firebase-app-compat.js!./firebase-app-compat.js'
import 'file-loader?name=firebase-messaging-compat.js!./firebase-messaging-compat.js'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false
    }
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (query.state.status === 'error') {
        console.log(`Something went wrong: ${error.message}`)
      }
    }
  })
})

const AuthErrorPage = () => {
  const auth = useAuth()

  const handleSignOut = () => {
    logout()
    auth.signOutRedirect()
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '20px',
        textAlign: 'center'
      }}
    >
      <h2>Authentication Error</h2>
      <p style={{ maxWidth: '500px', marginBottom: '24px', color: '#666' }}>
        The authentication link is invalid or has expired. This can happen when
        using an outdated URL or when the session has timed out.
      </p>
      <Button variant="contained" color="primary" onClick={handleSignOut}>
        Sign out and try again
      </Button>
    </div>
  )
}

const App = () => {
  const [oidcError, setOidcError] = useState(null)

  return (
    <AuthProvider {...oidcConfig} onSignInError={setOidcError}>
      <SnackbarProvider maxSnack={10} persist anchorOrigin={{ horizontal: 'right', vertical: 'top' }}>
        <QueryClientProvider client={queryClient}>
          {oidcError ? <AuthErrorPage /> : <AppInner />}
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </SnackbarProvider>
    </AuthProvider>
  )
}

export default App
